import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, FilterPipe, TranslationPipe } from '@prekog/common-ui';
import { Material } from '../../products/product-list/material.model';
import { BookWithSerienumber } from '../addserie/bookwithserienumber';
import { SelectedProduct } from '../addserie/selectedproduct';
import { Serie } from '../serie';
import { GetSerieRequest } from './getserierequest';
import { GetSerieResponse } from './getserieresponse';
import { SerieProduct } from './serieproduct';
import { SerieProductBasicInfo } from './serieproductbasicinfo';
import { UpdateSerieRequest } from './updateserierequest';

@Component({
    selector: 'app-updateserie',
    templateUrl: './updateserie.component.html',
    styleUrls: ['./updateserie.component.scss'],
    standalone: true,
    imports: [MatIconModule, FilterPipe, FormsModule, ReactiveFormsModule, DragDropModule, CommonModule, RouterModule, TranslationPipe]
})
export class UpdateserieComponent implements OnInit {
    filteredBooks: Material[] = [];

    getSerieUrl = '/admin/getSerieWithProducts';

    productsExcludingSerie?: SerieProductBasicInfo[];

    routerLink = '';

    searchText = '';

    serie: Serie = {};

    serieForm?: FormGroup;

    serieNumber = 0;

    serieNumberForm?: FormGroup;

    serieNumberToAdd = 0;

    storeBaseUrl = '';

    updateableProducts?: SerieProductBasicInfo[];

    updateSerieUrl = '/admin/update-serie';

    constructor(
        private _fb: FormBuilder,
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
        private _apiRequestService: ApiRequestService,
        public _router: Router
    ) {
        this.storeBaseUrl = _storeBaseUrl;
        this.createSerieForm();
        this.createSerieNumberForm();
    }

    ngOnInit(): void {
        if (sessionStorage.getItem('token')) {
            const lastSegmentOfUrl = window.location.href.split('/').pop();
            const routerLink = lastSegmentOfUrl as string;
            this.routerLink = routerLink;
            const getSerieRequest: GetSerieRequest = {
                routerLink: routerLink
            };
            this._apiRequestService
                .sendRequest<GetSerieRequest, GetSerieResponse>(this.storeBaseUrl, getSerieRequest, true, this.getSerieUrl)
                .subscribe((response) => {
                    this.serie = response.serie!;
                    this.updateableProducts = response.serieProducts;
                    this.productsExcludingSerie = response.productsExcludingSerie;
                    this.filteredBooks = this.productsExcludingSerie!;
                    if (sessionStorage.getItem('product')) {
                        const product = JSON.parse(sessionStorage.getItem('product') as string) as SerieProductBasicInfo;

                        const index = this.productsExcludingSerie?.indexOf(product);
                        if (this.productsExcludingSerie && index !== undefined && index !== -1) {
                            this.productsExcludingSerie.splice(index, 1);
                            this.updateableProducts?.push(product);
                        }
                        sessionStorage.removeItem('product');
                    }
                });
        } else {
            this._router.navigateByUrl('/');
        }
    }

    addProduct(product: SerieProductBasicInfo) {
        const index = this.productsExcludingSerie?.indexOf(product);
        if (this.productsExcludingSerie && index !== undefined && index !== -1) {
            this.productsExcludingSerie?.splice(index, 1);
        }
        this.updateableProducts?.push(product);
    }

    deleteFromUpdateableProductList(product: BookWithSerienumber) {
        const index = this.updateableProducts?.indexOf(product);
        if (this.updateableProducts && index !== undefined && index !== -1) {
            this.updateableProducts?.splice(index, 1);
        }
        this.productsExcludingSerie?.push(product);
    }

    createSerieForm() {
        this.serieForm = this._fb.group({
            serieName: ['', [Validators.required]]
        });
    }

    updateSerie() {
        this.serie.serieName = this.serieForm?.controls['serieName'].value as string | undefined;

        this._apiRequestService
            .sendRequest<
                UpdateSerieRequest,
                HttpResponse<any>
            >(this.storeBaseUrl, this.createUpdateSerieRequest(), true, this.updateSerieUrl, true)
            .subscribe();
    }

    createUpdateSerieRequest(): UpdateSerieRequest {
        const selectedProductList: SelectedProduct[] = (this.updateableProducts ?? []).map((updateableProduct, index) => ({
            productId: updateableProduct.id,
            serieNumber: index + 1
        }));

        const updateSerieRequest: UpdateSerieRequest = {
            serie: this.serie,
            selectedUpdateProductList: selectedProductList
        };

        return updateSerieRequest;
    }

    createSerieNumberForm() {
        this.serieNumberForm = this._fb.group({
            serieNumber: ['', [Validators.required]]
        });
    }

    collectSerieNumber() {
        this.serieNumber = this.serieNumberForm?.controls['serieNumber'].value as number;
    }

    drop(event: CdkDragDrop<SerieProduct[]>): void {
        moveItemInArray(this.updateableProducts!, event.previousIndex, event.currentIndex);
    }
}
